var exports = {
  "z": "ItemIcon__mpFwXq",
};

module.exports = exports;
